module.exports = "<div class=\"wrapper\">\n  <app-authenticate>\n  </app-authenticate>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main